// styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import { Colors, FontWeight } from '../../../../assets/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  table: {
    marginBottom: 80,
    marginTop: 30,
  },
  title:{},
  tableHead:{
    fontWeight:`${FontWeight.Bold} !important`,
    fontSize:'16px !important',
    color:'black !important',
     '&.MuiTableCell-root':{
      border: `1px solid ${Colors.Gray5} !important`,
    }
  },
  tableContainer:{
    backgroundColor: 'white', 
    borderRadius:'5px',
    marginBottom:'20px'
  },
  columnTitle: {
    color: Colors.Black,
    fontWeight: FontWeight.Bold,
    fontSize: 16,
    padding: '12px',
  },
  sectionTitle: {
    fontSize: '16px !important',
    fontWeight: FontWeight.Light,
    color: Colors.Black,
    padding: '12px',
  },
  subsectionTitle: {
    fontSize: '16px !important',
    fontWeight: `${FontWeight.Light} !important`,
    color: `${Colors.Black} !important`,
    paddingLeft: '30px !important',
    padding: '12px !important',
  },
  sectionAmount: {
    width: '25%',
    color: `${Colors.Gray} !important`,
    fontSize: 14,
    padding: '12px',
  },
  subsectionAmount: {
    width: '25%',
    color: `${Colors.Gray} !important`,
    fontSize: 14,
    padding: '12px',
  },
  contentTitle: {
    marginBottom: '24px !important',
  },
}));

export const useTableCellStyles = makeStyles((theme: Theme) => ({
  root: {
    '&.MuiTable-root':{
      border: `1px solid ${Colors.Gray5} !important`,
    },
  },
  cell:{
    '&.MuiTableCell-root':{
      border: `1px solid ${Colors.Gray5} !important`,
    }
  },
}));